import { OktaStoreEnum } from '../oktaClient.enum';
import { IOktaStorage } from '../oktaClient.interface';
import { CookieStore } from './cookieStore';
import { LocalstorageStore } from './localstorageStore';

export const storageLocationBuilders: { [key in OktaStoreEnum]: IOktaStorage } = {
  [OktaStoreEnum.CACHE]: new CookieStore(),
  [OktaStoreEnum.LOCALSTORAGE]: new LocalstorageStore(),
};
